// Shown while the session is checked and the app layout loads: the splash's
// first frame (see splashMark.ts), so a first load goes index.html loader →
// this → splash or app without any other placeholder in between.
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FULL_AR, MARK_HEIGHT, MARK_TOP, OKT_FRACTION, setMarkOnScreen } from './splashMark';

export function OktoberLoadingScreen() {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    setMarkOnScreen(true);
  }, []);

  return (
    <div
      role="status"
      aria-label={t('oktober.loading', 'Loading…')}
      style={{ position: 'fixed', inset: 0, background: 'var(--om-cream)' }}
    >
      <div style={{ position: 'fixed', left: '50%', top: MARK_TOP, transform: 'translate(-50%, -50%)' }}>
        <span
          style={{
            display: 'block',
            overflow: 'hidden',
            height: MARK_HEIGHT,
            width: `calc(${MARK_HEIGHT} * ${(FULL_AR * OKT_FRACTION).toFixed(4)})`,
          }}
        >
          <span
            style={{
              display: 'block',
              height: MARK_HEIGHT,
              width: `calc(${MARK_HEIGHT} * ${FULL_AR.toFixed(4)})`,
              background: 'var(--om-accent)',
              WebkitMaskImage: 'url(/brand/logo-oktober.svg)',
              maskImage: 'url(/brand/logo-oktober.svg)',
              WebkitMaskRepeat: 'no-repeat',
              maskRepeat: 'no-repeat',
              WebkitMaskSize: 'contain',
              maskSize: 'contain',
              WebkitMaskPosition: 'left center',
              maskPosition: 'left center',
            }}
          />
        </span>
      </div>
    </div>
  );
}
